import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { OrgAuthUrlResponse } from '../models/staff/org-auth-url-response.model';
import { OrganizationExt } from '../models/staff/organization-ext.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';
import { OrgSignAuthRequest } from '../models/staff/org-sign-auth-request.model';

@Injectable({
  providedIn: 'root',
})
export class OmUserOrgService extends RequestService<OrganizationExt> {
  static PATH = '/om/user/org';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, OmUserOrgService.PATH, globalService.debugUrl);
  }

  getOrgAuthUrl(id: number) {
    return this.httpClient.get<OrgAuthUrlResponse>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${OmUserOrgService.PATH}/getOrgAuthUrl/${id}`
    );
  }

  signAuth(info: OrgSignAuthRequest) {
    return this.httpClient.post(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${OmUserOrgService.PATH}/signAuth`,
      info
    );
  }

  cancleSignAuth(authFlowId: string) {
    return this.httpClient.post(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${OmUserOrgService.PATH}/cancleSignAuth`,
      {
        authFlowId,
      }
    );
  }
}
